import { PeekyState } from 'peeky/peeky.state';

export async function init($map: JQuery, state: PeekyState) {
	
	if ($('#leafletCss').length <= 0) {
		$('head').append('<link rel="stylesheet" id="leafletCss" href="https://peeky.com/_static/js/leaflet/leaflet.peeky.css" type="text/css" />');
	}
  const { default: L } = await import(/* webpackChunkName: "leaflet" */'leaflet');
	
	let canvas = document.createElement("canvas");
	let ctx = canvas.getContext('2d');
	let quotaRed = 3;//21;//3;
	let quotaGreen = 4;//71;//4;
	let quotaBlue = 1;//8;//1;
	let quotaDividerTune = -0.5;
	let quotaDivider = quotaRed + quotaGreen + quotaBlue + quotaDividerTune;


	class Grayscale extends L.TileLayer {
		_tileOnLoad(done, tile: HTMLImageElement) {
			if (tile.getAttribute('greyscaled')) {
				return;
			}
			const width = tile.width;
			const height = tile.height;
			tile.setAttribute('crossorigin', 'anonymous');
			tile.setAttribute('greyscaled', 'true');
			canvas.width = width;
			canvas.height = height;
			ctx.drawImage(tile, 0, 0);
			const imageData = ctx.getImageData(0, 0, width, height);
			const pixel = imageData.data;
			for (let i = 0, n = pixel.length; i < n; i += 4) {
				pixel[i] = pixel[i + 1] = pixel[i + 2] = (quotaRed * pixel[i] + quotaGreen * pixel[i + 1] + quotaBlue * pixel[i + 2]) / quotaDivider;
			}
			ctx.putImageData(imageData, 0, 0);
			tile.removeAttribute("crossorigin");
			tile.src = ctx.canvas.toDataURL();
			(<any>L.TileLayer.prototype)._tileOnLoad.call(this, done, tile);
		}
	}


  $map.each(function() { 
		const mapContainer = this;
		let lat = parseFloat(mapContainer.dataset.mappinlat);
		let long = parseFloat(mapContainer.dataset.mappinlong);
		let zoom = parseFloat(mapContainer.dataset.mapzoom);
		const iconWidth = parseFloat(mapContainer.dataset.iconwidth);
		const iconHeight = parseFloat(mapContainer.dataset.iconheight);
		const map = L.map(mapContainer, {
			scrollWheelZoom: false
		});
		map.attributionControl.setPrefix(false);
		const resize = function() {
			setTimeout(function() {
				map.invalidateSize();
			}, 0);
		}

		if (isNaN(lat)) {
			lat = 38.897957;
		}
		if (isNaN(long)) {
			long = -77.036560;
		}
		if (isNaN(zoom)) {
			zoom = 5;
		}

		state.on('postStateShown', function() {
			resize();
		});
		pk.on('resize', resize);
		state.on('attached', function() {
			pk.on('resize', resize);
		});
		state.on('detached', function() {
			pk.off('resize', resize);
		});
		
		if (lat && long) {
			map.setView([lat, long], zoom);
			const icon = new L.Icon({
				iconUrl: 'data:image/svg+xml;utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256,0C167.641,0,96,71.625,96,160c0,24.75,5.625,48.219,15.672,69.125C112.234,230.313,256,512,256,512l142.594-279.375C409.719,210.844,416,186.156,416,160C416,71.625,344.375,0,256,0z M256,256c-53.016,0-96-43-96-96s42.984-96,96-96c53,0,96,43,96,96S309,256,256,256z"/></svg>',
				iconSize: [iconWidth, iconHeight],
				iconAnchor: [iconWidth/2, iconHeight]
			});
			const marker = new L.Marker([lat, long], { icon: icon });
			// marker.setLatLng([lat, long]);
			marker.addTo(map);
		}

		const tileLayer = new Grayscale('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> Contributors',
			maxZoom: 18,
			crossOrigin: true
		});
		tileLayer.addTo(map);
	});

}